<template>
  <div class="user">
    <!--
    <div class="photo">
     <img :src="avatar" alt="avatar" />
    </div>
    -->

    <div class="user-info" align="Center">
      <a :aria-expanded="!isClosed" data-toggle="collapse" @click.stop="toggleMenu" @click.capture="clicked">
        <span>{{ title }}<b class="caret"/></span>
        <span style="font-size: .75rem; color: #aaa;">Technician</span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <!-- <li>
                <a href="#vue">
                  <span class="sidebar-mini">&nbsp;</span>
                  <span class="sidebar-normal">My Profile</span>
                </a>
              </li> -->
              <li>
                <a href="#" @click="goToSettings" class="nav-link" style="display: flex;align-items: center;">
                  <md-icon>settings</md-icon>
                  My Settings
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions"
import moment from "moment"
export default {
  components: {
    CollapseTransition
  },
  props: {
    title: {
      type: String,
      default: sessionStorage.getItem("firstname") + " " + sessionStorage.getItem("lastname")
    },
    lastScreening: {
      type: String,
      default: sessionStorage.getItem("lastScreening")
    },
    /*
    memberDate: {
      type: String,
      default: sessionStorage.getItem("memberDate")
    },
    */
    avatar: {
      type: String,
      default: "http://via.placeholder.com/400/3b3b3b/3b3b3b/?text=." // "../../img/GlobeChek_EYE.png"
    }
  },
  data() {
    return {
      isClosed: true
    }
  },
  computed: {
    memberDate() {
      var md = sessionStorage.getItem("memberDate")
      return md ? moment(md, "MM/DD/YYYY HH:kk A").format("ll") : ""
    }
  },
  methods: {
    clicked: function(e) {
      e.preventDefault()
    },
    toggleMenu: function() {
      this.isClosed = !this.isClosed
    },
    goToSettings() {
      this.$router.push('/portal/technician/settings');
    }
  }
}
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
